export enum RechargerTransactionStatus {
    PENDIENT = 1,            // pendiente
    READY = 2,                // descarga
}